import type { WithActiveBranchId } from '@app/api/shared';

export enum ClientsMergeEndpoints {
  CheckClientForDuplicate = 'CheckClientForDuplicate',
  MergeClientsAtSameBranch = 'MergeClientsAtSameBranch',
}

export interface ModelClientCheck {
  ClientId: number;
  ClientPhone: string | null;
}

export interface ModelClientCheckResult {
  BranchId: number;
  CheckClientId: number;
  CheckLeadId: number;
  CheckClientPhone: string | null;
  IsDuplicated: boolean;
  IsMergePossible: boolean;
  ExistingClientId: number;
  ExistingLeadId: number;
}

export interface ModelClientsForMerge {
  ClientId1: number;
  ClientId2: number;
}

export interface ModelClientLeadInfo {
  ClientId: number;
  LeadId: number;
  BranchId: number;
}

export type CheckClientForDuplicateRequest = WithActiveBranchId<{
  data: ModelClientCheck;
}>;

export type MergeClientsAtSameBranchRequest = WithActiveBranchId<{
  data: ModelClientsForMerge;
}>;

export type CheckClientForDuplicateResponse = ModelClientCheckResult;
export type MergeClientsAtSameBranchResponse = ModelClientLeadInfo;
